import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(public)/error.tsx");
